import { defineMessages } from 'react-intl';

export const tailoringHeadingMessages = defineMessages({
  productInfoModalTitle: {
    id: 'tailoringHeading.productInfoModalTitle',
    defaultMessage: 'Product info',
    description: 'Product info modal title',
  },
  productInfoModalIdLabel: {
    id: 'tailoringHeading.productInfoModalIdLabel',
    defaultMessage: 'Navigator Identifier',
    description: 'Product info modal id label',
  },
  productInfoModalNameLabel: {
    id: 'tailoringHeading.productInfoModalNameLabel',
    defaultMessage: 'Name',
    description: 'Product info modal name label',
  },
  productInfoModalDescriptionLabel: {
    id: 'tailoringHeading.productInfoModalDescriptionLabel',
    defaultMessage: 'Description',
    description: 'Product info modal description label',
  },
  productInfoModalVersionLabel: {
    id: 'tailoringHeading.productInfoModalVersionLabel',
    defaultMessage: 'Version',
    description: 'Product info modal version label',
  },
  productInfoModalProductIdentifierLabel: {
    id: 'tailoringHeading.productInfoModalProductIdentifierLabel',
    defaultMessage: 'Product Identifier',
    description: 'Product info modal product identifier label',
  },
  productInfoModalProjectIdentifierLabel: {
    id: 'tailoringHeading.productInfoModalProjectIdentifierLabel',
    defaultMessage: 'Project Identifier',
    description: 'Product info modal project identifier label',
  },
  productInfoModalNavigatorIdentifierLabel: {
    id: 'tailoringHeading.productInfoModalNavigatorIdentifierLabel',
    defaultMessage: 'Navigator Identifier',
    description: 'Product info modal navigator identifier label',
  },
});
